import React from "react";
import {useState,useEffect} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Box} from "@mui/system";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import {confirmDialog} from "primereact/confirmdialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dropdown} from "primereact/dropdown";
import {InputTextarea} from 'primereact/inputtextarea';
import Message from "../Helpers/Message.js";
import {fetch_url_post} from "../../Sources/js/app.js";

let oper="";

let defaultInputValues={
	id: null,
	name: "",
	observations: "",
	filter_templates: "",
};

let defaultInputValuesProducts={
	id: null,
	centers_requests_templates_id: 0,
	product_id: 0,
	product_mu_id: "",
	quantity: 0,
	filter_products: "",
	product_type_id: 0,
	filter_product_type: "",
	observations: "",
	multiplier: 1,
};

let defaultDataValues={
	templatesList: [],
	templateProductsList: [],
};

let defaultDialogValues={
	openAddEdit: false,
	titleAddEdit: "",
	openListProducts: false,
	titleListProducts: "",
	openAddEditProduct: false,
	titleAddEditProduct: "",
};

let defaultInputError={
	disableSave: false,
	errorText: "",
};

let multiplierList=[
	{label: "1",value: 1},
	{label: "2",value: 2},
	{label: "3",value: 3},
	{label: "4",value: 4},
	{label: "5",value: 5},
	{label: "6",value: 6},
	{label: "7",value: 7},
	{label: "8",value: 8},
	{label: "9",value: 9},
	{label: "10",value: 10},
	{label: "11",value: 11},
	{label: "12",value: 12},
];

let initialValue={};
let currentTemplate={};

const CentersRequestTemplates = (props) => {

	var timerId=null;
	defaultInputValues.id=(props.centerId?props.centerId:null);

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [dataValues, setDataValues] = useState(defaultDataValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [inputError, setInputError] = useState(defaultInputError);	
	const [blockScreen, setBlockScreen] = useState(false);
	const [templatesList, setTemplatesList] = useState([]);
	const [inputValuesProducts, setInputValuesProducts] = useState(defaultInputValuesProducts);
	const [templateProductsList, setTemplateProductsList] = useState([]);	
	const [productsList, setProductsList] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();

	const handleChange = evt => {
		const {name, value} = evt.target;
		if(name==="name") {
			let found=false;
			if(dataValues.templatesList.length>0) {
				dataValues.templatesList.forEach(element => {
					if((value.toUpperCase()===element.name.toUpperCase())&&((value!==initialValue.name)||(!initialValue))) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un sablon cu acest nume!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_templates") {
			setTemplatesList(dataValues.templatesList.filter((template)=>((template.name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		setInputValues({...inputValues,[name]:value});
	}

	const handleChangeProducts = evt => {
		const {name, value} = evt.target;
		let state_update=0;
		if(name==="product_id") {
			let tmp=dataValues.productsList.filter((product)=>(product.id===value));
			setInputValuesProducts({...inputValuesProducts,product_mu_id:tmp[0].product_mu_id,
															product_id:value
			});
			state_update=1;
			let found=false;
			if(dataValues.templateProductsList.length>0) {
				dataValues.templateProductsList.forEach(element => {
					if((value===element.product_id)&&(tmp[0].product_mu_id===element.product_mu_id)) {
						found=true;
					}
				});
			}
			tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un produs similar adaugat!":""),
			}
			setInputError(tmp);
		}
		if(name==="product_mu_id") {
			let found=false;
			if(dataValues.templateProductsList.length>0) {
				dataValues.templateProductsList.forEach(element => {
					if((value===element.product_mu_id)&&(inputValuesProducts.product_id===element.product_id)) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un produs similar adaugat!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_products") {
			setTemplateProductsList(dataValues.templateProductsList.filter((product)=>((product.product_name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		if(name==="product_type_id") {
			setProductsList(dataValues.productsList.filter((product)=>((product.product_type_id===value)||(value==="")||(!value))));
		}
		if(name==="filter_product_type") {
			setTemplateProductsList(dataValues.templateProductsList.filter((product)=>((product.product_type_id===value)||(value==="")||(!value))));
			console.log(value);
		}
		if(!state_update) {
			setInputValuesProducts({...inputValuesProducts,[name]:value});
		}
	}

	const handleButton = (evt,what,elementData) => {
		if(what==="add") {
			setInputValues(defaultInputValues);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Adaugare sablon nou"});
			setInputError(defaultInputError);
		}
		if(what==="edit") {
			elementData.filter_templates=inputValues.filter_templates;
			initialValue=elementData;
			setInputValues(elementData);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Editare sablon "+elementData.name});
			setInputError(defaultInputError);
		}
		if(what==="delete") {
			let url="deleteTemplate";
			url+="?session_id="+props.session.sessId;
			oper="delete";
			let data={
				id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValues.name==="") {
				setMessageText("Eroare: Completati campul nume!");				
				document.getElementById("name").classList.add("required_input_error");
				return false;
			}
			let url="saveTemplate";
			url+="?session_id="+props.session.sessId;
			oper="save";
			let data={...inputValues};
			data.only_template="1";
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="list_products") {
			let url="getTemplateProducts";
			url+="?session_id="+props.session.sessId;
			currentTemplate=elementData;
			oper="get_template_products";
			let data={
				centers_requests_templates_id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="add_product") {
			setInputValuesProducts(defaultInputValuesProducts);
			setDialogValues({...dialogValues,openAddEditProduct: true,titleAddEditProduct: "Adaugare produs nou in sablon"});
			setInputError(defaultInputError);
		}
		if(what==="edit_product") {
			elementData.filter_products=inputValuesProducts.filter_products;
			elementData.filter_product_type=inputValuesProducts.filter_product_type;
			setProductsList(dataValues.productsList.filter((product)=>((product.product_type_id===elementData.product_type_id)||(elementData.product_type_id==="")||(!elementData.product_type_id))));			
			setInputValuesProducts(elementData);
			setDialogValues({...dialogValues,openAddEditProduct: true,titleAddEditProduct: "Editare produs "});
			setInputError(defaultInputError);
		}
		if(what==="delete_product") {
			let url="deleteTemplateProduct";
			url+="?session_id="+props.session.sessId;
			oper="delete_template_product";
			let data={
				id: elementData.id,
				centers_requests_templates_id: currentTemplate.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_product") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(!inputValuesProducts.product_id) {
				setMessageText("Eroare: Alegeti un produs din lista!");				
				document.getElementById("product_id").classList.add("required_input_error");
				return false;
			}
			if(!inputValuesProducts.product_mu_id) {
				setMessageText("Eroare: Alegeti o unitate de masura!");				
				document.getElementById("product_mu_id").classList.add("required_input_error");
				return false;
			}
			if(inputValuesProducts.quantity==="") {
				setMessageText("Eroare: Completati cantitatea!");				
				document.getElementById("product_id").classList.add("required_input_error");
				return false;
			}
			let url="saveTemplateProduct";
			url+="?session_id="+props.session.sessId;
			oper="save_template_product";
			let data={...inputValuesProducts};
			data.centers_requests_templates_id=currentTemplate.id;
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
			setMessageText("");
		}
		if(result.ok===0) {
			setMessageText("Eroare: "+result.error);
			return false;
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if((oper==="get")||(oper==="save")||(oper==="delete")) {
			setDialogValues(defaultDialogValues);
			if(oper==="get") {
				setDataValues({...dataValues,templatesList:(result.templatesList?result.templatesList:[]),
											productsList:(result.productsList?result.productsList:[]),
											MUsList:(result.MUsList?result.MUsList:[]),
											centersList:(result.centersList?result.centersList:[]),
											productsTypesList:(result.productsTypesList?result.productsTypesList:[])
				});
			}else{
				setDataValues({...dataValues,templatesList:(result.templatesList?result.templatesList:[])});				
			}
			setTemplatesList(result.templatesList?result.templatesList
																				.filter((template)=>((template.name.toLowerCase().indexOf(inputValues.filter_templates.toLowerCase())>-1))||(inputValues.filter_templates===""))
			:[]);
			setProductsList(result.productsList?result.productsList:[]);
            if(!dataOk) {
                setDataOk(true);
            }
			oper="";
		}
		if((oper==="get_template_products")||(oper==="save_template_product")||(oper==="delete_template_product")) {
			setDataValues({...dataValues,templateProductsList:(result.templateProductsList?result.templateProductsList:[])});
			setInputValuesProducts(defaultInputValuesProducts);
			setTemplateProductsList(result.templateProductsList?result.templateProductsList
																					.filter((product)=>((product.product_name.toLowerCase().indexOf(inputValuesProducts.filter_products.toLowerCase())>-1))||(inputValuesProducts.filter_products===""))
																					.filter((product)=>((product.product_type_id===inputValuesProducts.filter_product_type)||(inputValuesProducts.filter_product_type==="")))
			:[]);
			setDialogValues({...dialogValues,openListProducts: true,titleListProducts: "Lista produse pentru sablonul ["+currentTemplate.name+"]",
											openAddEditProduct: false,titleAddEditProduct: ""
			});
			oper="";
		}
	}

	const fail_handler = () => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
		}
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	const wait_handler = () => {
		setBlockScreen(true);
		setMessageText("Operatiunea este in curs...");
	}

	useEffect(() => {
		if(props.session.sessId) {
			oper="get";
			let url="getTemplates";
			url+="?session_id="+props.session.sessId;
			let data={};
			fetch_url_post(url,data,success_handler,fail_handler);
		}else{
			navigate("/login");
		}
	},[props.session.sessId]);

	const addEditDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEdit} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})} className="responsive-dialog-med">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="name">Nume*</label>
						<InputText name="name" id="name" style={{"width":"100%"}} value={inputValues.name} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputText name="observations" id="observations" style={{"width":"100%"}} value={inputValues.observations} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const listProductsDialog = () => {
		return(
			<Dialog header={dialogValues.titleListProducts} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openListProducts:false})} className="responsive-dialog-big">
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={12} md={4} lg={4} xl={5} className="field padding-med">
							<InputText name="filter_products" id="filter_products" style={{"width":"100%"}} value={inputValuesProducts.filter_products} placeholder="Cauta produs..." onChange={(evt) => handleChangeProducts(evt)}/>							
						</Grid>						
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3} className="field padding-med">
							<Dropdown name="filter_product_type" id="filter_product_type" style={{"width":"100%"}} filter options={dataValues.productsTypesList} placeholder="Filtrare categorie..." showClear optionLabel="name" optionValue="id" value={inputValuesProducts.filter_product_type} onChange={(evt) => handleChangeProducts(evt)}/>
						</Grid>						
						<Grid item xs={12} sm={12} md={5} lg={5} xl={4} className="field padding-med text-right">
							<Button label="Adauga produs" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add_product")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<DataTable
							id="centers_requests_products"
							value={templateProductsList}
							scrollable
							scrollHeight="60vh"
							style={{"minHeight":"63vh"}}
							scrollDirection="both"
							stripedRows
							resizableColumns
							rowGroupMode="rowspan"
							groupRowsBy="product_type"
							sortMode="single"
							sortField="product_type"
							sortOrder={1}
							emptyMessage="Nu exista inregistrari"
						>
							<Column field="product_type" header="Tip produs" style={{"width":"23%","backgroundColor":"#FFFFFF"}} body={tableColTemplateProducts}></Column>
							<Column field="product_name" header="Produs" style={{"width":"38%"}}></Column>
							<Column field="product_mu" header="U.M." style={{"width":"130px"}}></Column>
							<Column field="multiplier" header="Multi." style={{"width":"60px","textAlign":"center","display":"none"}}></Column>							
							<Column field="observations" header="Observatii" style={{"overflow":"hidden","maxWidth":"240px","textOverflow":"ellipsis"}}></Column>
							<Column field="buttons" header="" style={{"width":"195px"}} body={tableColTemplateProducts}></Column>
						</DataTable>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
			</Dialog>
		);
	}

	const addEditProductDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEditProduct} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEditProduct:false})} className="responsive-dialog-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="product_type_id">Categorie*</label>
						<Dropdown name="product_type_id" id="product_type_id" style={{"width":"100%"}} filter options={dataValues.productsTypesList} showClear optionLabel="name" optionValue="id" value={inputValuesProducts.product_type_id} onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="product_id">Produs* ({productsList.length} produse gasite)</label>
						<Dropdown name="product_id" id="product_id" style={{"width":"100%"}} filter options={productsList} optionLabel="name" optionValue="id" value={inputValuesProducts.product_id} onChange={(evt) => handleChangeProducts(evt)} disabled={(inputValuesProducts.product_type_id?false:false)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="product_mu_id">Unitate de masura*</label>
						<Dropdown name="product_mu_id" id="product_mu_id" style={{"width":"100%"}} options={dataValues.MUsList} filter value={inputValuesProducts.product_mu_id} optionLabel="name" optionValue="id" onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="quantity">Cantitate*</label>
						<InputText name="quantity" id="quantity" style={{"width":"100%"}} value={inputValuesProducts.quantity} onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="multiplier">Multiplicator*</label>
						<Dropdown name="multiplier" id="multiplier" style={{"width":"100%"}} options={multiplierList} value={inputValuesProducts.multiplier} disabled={true}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputTextarea name="observations" id="observations" style={{"width":"100%","height":"90px"}} rows={5} cols={30} value={inputValuesProducts.observations} onChange={(evt) => handleChangeProducts(evt)}/>							
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save_product")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEditProduct:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const tableColTemplate = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza sablon" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit",row_data)}/>
					<Button label="Produse" icon="pi pi-list" tooltip="Lista de produse" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"list_products",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge sablon" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete",row_data)}/>
				</span>
			);
		}
	}

	const tableColTemplateProducts = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza produs" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit_product",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge produs" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete_product",row_data)}/>
				</span>
			);
		}
		if(column.field==="product_type") {
			return(
				<div className="flex align-items-center gap-2">
					<span className="font-bold">{row_data.product_type}</span>
				</div>
			);
		}		
	}

	const confirm = (evt,what,elementData) => {
		if((what==="delete")||(what==="delete_product")) {
			confirmDialog({
				message: "Sigur doriti stergerea?",
				header: "Confirmare stergere",
				icon: "pi pi-exclamation-triangle",
				accept: () => handleButton(evt,what,elementData),
				reject: () => null,
			});
		}
	}

	if(dataOk) {
		return(
			<BlockUI blocked={blockScreen} fullScreen>
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={4} md={4} lg={3} xl={3} className="field padding-med">
							<InputText name="filter_templates" id="filter_templates" style={{"width":"100%"}} value={inputValues.filter_centers} placeholder="Cauta sablon..." onChange={(evt) => handleChange(evt)}/>							
						</Grid>						
						<Grid item xs={12} sm={4} md={4} lg={6} xl={6} className="field padding-med text-left">
							<h6 style={{"marginTop":"9px","color":"#000000"}}>{templatesList.length} {(((templatesList.length>1)||(templatesList.length===0))?" inregistrari gasite.":" inregistrare gasita.")}</h6>
						</Grid>						
						<Grid item xs={12} sm={4} md={4} lg={3} xl={3} className="field padding-med text-right">
							<Button label="Adauga sablon nou" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<div className="card">
							<DataTable
								value={templatesList}
								scrollable
								scrollHeight="60vh"
								style={{"minHeight":"63vh"}}
								scrollDirection="both"
								stripedRows
								resizableColumns
								columnResizeMode="fit"
								responsiveLayout="stack"
								emptyMessage="Nu exista inregistrari"
							>
								<Column field="name" header="Nume" style={{"flexGrow":"1","flexBasis":"230px"}} sortable></Column>
								<Column field="observations" header="Observatii" style={{"flexGrow":"1","flexBasis":"255px"}}></Column>
								<Column field="reg_date_parsed" header="Data introducerii" style={{"flexGrow":"0","flexBasis":"180px"}} sortable></Column>
								<Column field="buttons" header="" style={{"flexGrow":"0","flexBasis":"291px"}} body={tableColTemplate}></Column>
							</DataTable>
						</div>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
				<ConfirmDialog />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
				{dialogValues.openAddEdit && addEditDialog()}
				{dialogValues.openListProducts && listProductsDialog()}
				{dialogValues.openAddEditProduct && addEditProductDialog()}
            </BlockUI>
		);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);		
	}
};

export default CentersRequestTemplates;


